<template>
    <div>
        <hts-drawer
            v-model="visible"
            :submit="handleSubmitFormAddVehicle"
            :title="$t('labels.addVehicle')"
            :rules="rulesAddVehicle"
            size="large"
            @close="closeOverSide">
            <hts-card :title="$t('labels.generalInformation')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataFormAddVehicle.licensePlate"
                        :label="$t('labels.vehicleModule.licensePlate')"
                        :required="true"
                        :color="props.color"
                        name="vehicleModule.licensePlate"
                        prop="vehicleModule.licensePlate" />

                    <hts-select-tracking-gps
                        v-model="dataFormAddVehicle.gpsTrackingType"
                        required
                        prop="gpsTrackingType"
                        name="gpsTrackingType"
                        :label="$t('labels.gpsTrackingType')" />
                </div>
            </hts-card>

            <hts-card :title="$t('labels.driverInfo')">
                <hts-card :title="$t('labels.primaryDriver')">
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="dataFormAddVehicle.otherCompanyDriver.fullName"
                            :label="$t('labels.fullName')"
                            required
                            :color="color"
                            name="fullName"
                            prop="fullName" />
                        <hts-form-phone
                            v-model="dataFormAddVehicle.otherCompanyDriver.phone"
                            :label="$t('labels.phone')"
                            required
                            prop="phone"
                            name="phone"
                            @updateCode="(val) => (dataFormAddVehicle.otherCompanyDriver.phone.code = val)" />
                        <hts-form-input
                            v-model="dataFormAddVehicle.otherCompanyDriver.idCardNumber"
                            :label="$t('labels.idCardNumber')"
                            required
                            :color="color"
                            name="idCardNumber"
                            prop="idCardNumber" />
                        <hts-select-user
                            v-model="dataFormAddVehicle.otherCompanyDriver.companyUserId"
                            v-model:name="dataFormAddVehicle.otherCompanyDriver.companyUserName"
                            :label="$t('labels.userAccount')"
                            prop="companyUserId"
                            :data-create-default="dataFormAddVehicle"
                            creatable />
                    </div>
                </hts-card>

                <hts-card
                    v-if="openAddCoDriver"
                    :title="$t('labels.coDriver')">
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-input
                            v-model="dataFormAddVehicle.otherCompanyCoDriver.fullName"
                            :label="$t('labels.fullName')"
                            required
                            :color="color"
                            name="fullName"
                            prop="coDriverIdFullName" />
                        <hts-form-phone
                            v-model="dataFormAddVehicle.otherCompanyCoDriver.phone"
                            :label="$t('labels.phone')"
                            required
                            prop="coDriverIdphone"
                            name="phone"
                            @updateCode="(val) => (dataFormAddVehicle.otherCompanyCoDriver.phone.code = val)" />
                        <hts-form-input
                            v-model="dataFormAddVehicle.otherCompanyCoDriver.idCardNumber"
                            :label="$t('labels.idCardNumber')"
                            required
                            :color="color"
                            name="idCardNumber"
                            prop="coDriverIdCardNumber" />
                        <hts-select-user
                            v-model="dataFormAddVehicle.otherCompanyCoDriver.companyUserId"
                            v-model:name="dataFormAddVehicle.otherCompanyCoDriver.companyUserName"
                            :label="$t('labels.userAccount')"
                            prop="companyUserId"
                            :data-create-default="dataFormAddVehicle"
                            creatable />

                        <!--
                          <hts-select-user
                          v-model="dataFormAddVehicle.companyUserId"
                          v-model:name="dataFormAddVehicle.companyUserName"
                          :label="$t('labels.userAccount')"
                          prop="companyUserId"
                          creatable />
                        -->
                    </div>
                </hts-card>

                <div>
                    <hts-form-button
                        v-if="!openAddCoDriver"
                        color="primary"
                        size="small"
                        @click="handleAddCoDriver">
                        Thêm tài xế phụ
                    </hts-form-button>

                    <hts-form-button
                        v-if="openAddCoDriver"
                        color="error"
                        size="small"
                        @click="handleCloseCoDriver">
                        Bỏ tài xế phụ
                    </hts-form-button>
                </div>
            </hts-card>
        </hts-drawer>
    </div>
</template>

<script setup lang="ts">
import form, { IVehicle } from './imports/form'

const { rules } = form

const store = $store()
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  column: {
    type: Number,
    default: 3
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const visible = ref(false)
const openPopupAddCategory = ref(false)
const dataFormAddVehicle = reactive<IVehicle>({ ...form.initFormVehicle })
const openAddCoDriver = ref<boolean>(false)

const emits = defineEmits(['close', 'refreshDataTables'])
const open = () => {
  Object.assign(configCont, store.globalSettings.getGlobalSettings.configCont || {})
  visible.value = true
  dataFormAddVehicle.type = 1
  if (dataFormAddVehicle?.otherCompanyDriver) {
    dataFormAddVehicle.otherCompanyDriver.phone = {
      countryCode: 'Vietnam +84',
      phone: '',
      code: '+84'
    }
  }

  if (dataFormAddVehicle?.otherCompanyCoDriver) {
    dataFormAddVehicle.otherCompanyCoDriver.phone = {
      countryCode: 'Vietnam +84',
      phone: '',
      code: '+84'
    }
  }
}
defineExpose({
  open
})

const closeOverSide = () => {
  visible.value = false
}

const rulesAddVehicle = computed(() => {
  if (!openAddCoDriver.value) {
    return {
      'vehicleModule.licensePlate': 'required',
      fullName: 'required',
      phone: 'required',
      idCardNumber: 'required'
    }
  }

  return {
    'vehicleModule.licensePlate': 'required',
    fullName: 'required',
    phone: 'required',
    idCardNumber: 'required',
    coDriverIdFullName: 'required',
    coDriverIdphone: 'required',
    coDriverIdCardNumber: 'required'
  }
})

const configCont: { [key: string]: any } = reactive({})

const vehicleCategory = ref({})

const handleSubmitFormAddVehicle = async () => {
  if (dataFormAddVehicle.type === 0 && !Object.keys(vehicleCategory.value).length) {
    openPopupAddCategory.value = true
    return
  }

  if (dataFormAddVehicle.type !== 0) {
    dataFormAddVehicle.parkingNodeId = null
  }

  if (!openAddCoDriver.value) {
    delete dataFormAddVehicle.otherCompanyCoDriver
  }

  const api = $urlPartner.vehicle.vehicle.add
  const data: any = await $api(api, { body: { ...dataFormAddVehicle } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.vehicleModule.addSuccess'))
    emits('close')
    emits('refreshDataTables')
    undo()
    visible.value = false
  }
}

const undo = () => {
  Object.assign(dataFormAddVehicle, { ...form.initFormVehicle })
  dataFormAddVehicle.tollStation = []
  vehicleCategory.value = {}
  dataFormAddVehicle.otherCompanyDriver = {
    fullName: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    idCardNumber: '',
    companyUserId: '',
    companyUserName: ''
  }

  dataFormAddVehicle.otherCompanyCoDriver = {
    fullName: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    idCardNumber: '',
    companyUserId: '',
    companyUserName: ''
  }
}

const handleAddCoDriver = () => {
  openAddCoDriver.value = true
}

const handleCloseCoDriver = () => {
  openAddCoDriver.value = false
}

const columnClass = computed(() => {
  switch (props.column) {
  case 1:
    return 'grid-cols-1'
  case 2:
    return 'grid-cols-2'
  case 3:
    return 'grid-cols-3'
  case 4:
    return 'grid-cols-4'
  case 5:
    return 'grid-cols-5'
  case 6:
    return 'grid-cols-6'
  case 7:
    return 'grid-cols-7'
  case 8:
    return 'grid-cols-8'
  case 9:
    return 'grid-cols-9'
  case 10:
    return 'grid-cols-10'
  case 11:
    return 'grid-cols-11'
  case 12:
    return 'grid-cols-12'
  }

  return 'grid-cols-1'
})
</script>
